import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Cookie } from 'lucide-react';

const STORAGE_KEY = 'electronico-cookie-consent';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      const t = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const respond = (choice) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ choice, at: Date.now() }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-md z-[70] animate-in fade-in slide-in-from-bottom-4"
      style={{ animationDuration: '400ms' }}
      data-testid="cookie-consent-banner"
    >
      <div className="neon-border rounded-2xl bg-[#0a1526]/95 backdrop-blur-xl p-5 shadow-2xl">
        <div className="flex items-start gap-3">
          <span className="h-10 w-10 rounded-xl bg-[#0ef3fe]/15 flex items-center justify-center shrink-0">
            <Cookie className="h-5 w-5 text-[#0ef3fe]" />
          </span>
          <div>
            <h4 className="font-display font-bold text-white text-base">We value your privacy</h4>
            <p className="text-sm text-white/55 mt-1 leading-relaxed">
              We use cookies to enhance your browsing experience and analyse site traffic. By clicking
              “Accept”, you consent to our use of cookies. Read our{' '}
              <Link to="/cookies" className="text-[#0ef3fe] hover:underline" data-testid="cookie-policy-link">Cookie Policy</Link>.
            </p>
          </div>
        </div>
        <div className="flex gap-3 mt-4">
          <button
            onClick={() => respond('declined')}
            className="flex-1 rounded-xl border border-white/15 py-2.5 text-sm font-semibold text-white/70 hover:text-white hover:border-white/30 transition-colors"
            data-testid="cookie-decline-button"
          >
            Decline
          </button>
          <button
            onClick={() => respond('accepted')}
            className="flex-1 rounded-xl bg-gradient-to-r from-[#0ef3fe] to-[#088ffe] text-black py-2.5 text-sm font-semibold hover:shadow-[0_0_24px_rgba(8,143,254,0.4)] transition-shadow"
            data-testid="cookie-accept-button"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
